import { PORTAL_ROUTER_LOOKUP_PATH } from '@willow/shared-iso';
import {
  PortalRouterLookupInput,
  PortalRouterLookupResponse,
  PortalRouterMatch,
  PortalRouterRateLimitedResponse,
} from '@willow/types-iso';

export type LookupOutcome =
  | { kind: 'RESOLVED'; portals: PortalRouterMatch[] }
  | { kind: 'RATE_LIMITED'; retryAfterSeconds: number };

export const lookupPortals = async (email: string, endpoint = PORTAL_ROUTER_LOOKUP_PATH): Promise<LookupOutcome> => {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email } satisfies PortalRouterLookupInput),
  });
  if (response.status === 429) {
    const body = PortalRouterRateLimitedResponse.parse(await response.json());
    return { kind: 'RATE_LIMITED', retryAfterSeconds: body.retryAfterSeconds };
  }
  if (!response.ok) {
    throw new Error(`Portal router lookup failed with status ${response.status}`);
  }
  const body = PortalRouterLookupResponse.parse(await response.json());
  return { kind: 'RESOLVED', portals: body.portals };
};
